import OnboardingRoutes from './onboarding'
export default OnboardingRoutes
